import React from "react";
import "./RedirectPage.css"; // Ensure you create this CSS file with appropriate styles

const RedirectPage = () => {
  return (
    <div className="redirect-page">
      <div className="content">
        <div className="header">
          <h1>GrowTube</h1>
        </div>
        <div className="spinner"></div>
        <h2>Redirecting...</h2>
        <p>Please wait while we redirect you to the next page.</p>
      </div>
      <footer className="footer">
        <p>© 2024 GrowTube. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default RedirectPage;
